import { Form, Input, message } from 'antd';
import { useChangePasswordMutation } from '@/services/auth-api';
import { LockSvg } from '@/assets/icons';
import Page from '@/components/page';
import Panel from '@/components/panel';
import Button from '@/components/button';
import PageTitle from '@/components/page-title';

const breadcrumb = ['User'];

const ChangePasswordPage = () => {
  const [form] = Form.useForm();

  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const onFinish = async (values) => {
    try {
      await changePassword(values).unwrap();
      form.resetFields();
      message.success('The password is successfully changed!');
    } catch (err) {
      form.setFields([
        {
          name: 'oldPassword',
          errors: ['Current password is incorrect'],
        },
      ]);
    }
  };

  return (
    <Page breadcrumb={breadcrumb} size="sm">
      <PageTitle label="Change Password" />
      <Form layout="vertical" form={form} onFinish={onFinish} requiredMark={false}>
        <Panel
          icon={<LockSvg />}
          title="Change Password"
          footer={
            <>
              <Button type="primary" htmlType="submit" loading={isLoading}>
                Change Password
              </Button>
            </>
          }
          color="secondary"
        >
          <Form.Item name="oldPassword" label="Current Password" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true },
              { pattern: /[A-Z]+/, message: 'Include upper case characters' },
              { pattern: /[a-z]+/, message: 'Include lower case characters' },
              { pattern: /[0-9]+/, message: 'Include at least on number' },
              { min: 6, message: 'Be at least 6 characters long' },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={['newPassword']}
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('New Password that you entered do not match'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Panel>
      </Form>
    </Page>
  );
};

export default ChangePasswordPage;
